<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>资源管理
      <i class="el-icon-arrow-right"></i>&nbsp;产品管理
    </div>

    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-button type="primary" style="width: 140px;" icon="el-icon-circle-plus-outline" @click="openCreateProductDialog">创建产品</el-button>
    </div>

    <section class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column
          prop="productName"
          label="产品名称"
          :width="150*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="productKey"-->
<!--          label="产品编号"-->
<!--          :width="160*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          prop="description"
          label="场景描述"
          :width="250*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="licenseCount"-->
<!--          label="License数量"-->
<!--          :width="120*navCollapse">-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--          prop="activeLicenseCount"-->
<!--          label="已激活License数量"-->
<!--          :width="150*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          prop=""
          label="License数量：已激活/总量"
          :width="215*navCollapse">
          <template slot-scope="scope">
            {{scope.row.activeLicenseCount}}/{{scope.row.licenseCount}}
          </template>
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="maxQps"-->
<!--          label="QPS"-->
<!--          :width="110*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          prop=""
          label="720P图像数量：已使用/总量（张）"
          :width="250*navCollapse">
          <template slot-scope="scope">
            {{formattedInt(scope.row.usedToken/1348)}}/{{formattedInt(scope.row.tokenCount/1348)}}
          </template>
        </el-table-column>

<!--        <el-table-column-->
<!--          prop=""-->
<!--          label="Token：已使用/总量（万个）"-->
<!--          :width="215*navCollapse">-->
<!--          <template slot-scope="scope">-->
<!--            {{formattedFloat(scope.row.usedToken/10000)}}/{{formattedFloat(scope.row.tokenCount/10000)}}-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column
          prop="createTime"
          label="创建时间"
          :width="170*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="expireTime"-->
<!--          label="资源到期时间"-->
<!--          :width="168*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          label="操作">
          <template slot-scope="scope">
<!--            <el-tooltip v-if="(scope.row.tokenCount-scope.row.usedToken) > 0" class="item" effect="dark" content="本产品有未用完套餐资源，不能新购" placement="top-start">-->
<!--              <el-button @click="purchase(scope.row)" :disabled="scope.row.tokenCount > 0" type="text" size="small">新购资源</el-button>-->
<!--            </el-tooltip>-->
            <el-tooltip v-if="!isExpire(productExpireDict[scope.row.productKey])" class="item" effect="dark" content="本产品有未用完套餐资源，不能新购" placement="top-start">
              <el-button @click="purchase(scope.row)" disabled type="text" size="small">新购资源</el-button>
            </el-tooltip>
            <el-button v-else @click="purchase(scope.row)" type="text" size="small">新购资源</el-button>

<!--            <el-tooltip v-if="(scope.row.tokenCount-scope.row.usedToken) > 0" class="item" effect="dark" content="本产品有未用完套餐资源，不能删除" placement="top-start">-->
<!--              <el-button @click="deleteProduct(scope.row)" disabled type="text" size="small">删除产品</el-button>-->
<!--            </el-tooltip>-->
            <el-tooltip v-if="!isExpire(productExpireDict[scope.row.productKey])" class="item" effect="dark" content="本产品有未用完套餐资源，不能删除" placement="top-start">
              <el-button @click="deleteProduct(scope.row)" disabled type="text" size="small">删除产品</el-button>
            </el-tooltip>
            <el-button v-else @click="deleteProduct(scope.row)" type="text" size="small">删除产品</el-button>

          </template>
        </el-table-column>

      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
      <br>
      <div v-if="total > 0" class="tip-ol-box">
        <ul type="disc" class="tip-ol">
          <li>体验套餐只能购买一次</li>
          <li>License激活后才会增加可用图像数量</li>
          <li>当前套餐资源用完或到期后才可以再次新购资源</li>
        </ul>
      </div>

      <el-dialog title="产品信息" :visible.sync="dialogFormVisible" width="640px">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="产品名称" prop="productName" :label-width="formLabelWidth">
            <el-input v-model="form.productName" type="text"
                      placeholder="请填写产品名称"
                      style="width: 420px"></el-input>
          </el-form-item>

          <el-form-item label="产品描述" prop="description" :label-width="formLabelWidth">
            <el-input clearable :rows="4" type="textarea" v-model="form.description"
                      placeholder="请填写产品使用场景"
                      style="width: 420px">

            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="createProduct">确 定</el-button>
        </div>
      </el-dialog>

    </section>

  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {mapState} from 'vuex'
import {
  dateTimeFormatter
} from '@/common/utils.js'

import {
  reqProductInfo,
  reqCreateProduct,
  reqDeleteProduct,
  reqProductHasValidResource
} from '@/api'

export default {
  name: 'Product',

  data() {
    return {
      tableData: {},
      productExpireDict: {},
      loading: true,

      dialogFormVisible: false,
      formData: '',
      form: {
        productName: '', // 产品名称
        description: ''  // 产品描述
      },
      formLabelWidth: '120px',
      rules: {
        productName: [
          { required: true, message: '请填写产品名称', trigger: 'blur' },
          { min: 4, max: 32, message: '长度在 4 到 32 个字符', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请简要填写产品使用场景', trigger: 'blur'}
        ]
      },

      currentPage: 1,
      total: 0,
      pageSize: 15
    }
  },

  async mounted() {
    await this.getProduct()
  },

  methods: {
    formattedFloat (num) {
      return parseFloat(parseFloat(num).toFixed(2)) // 保留两位小数
    },

    formattedInt (num) {
      return parseInt(parseInt(num).toFixed(0))
    },

    openCreateProductDialog () {
      this.dialogFormVisible = true
    },

    async createProduct () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          const result = await reqCreateProduct('/product/createProduct', this.form.productName, this.form.description)
          loading.close()
          if (result.code === 200) {
            this.dialogFormVisible = false
            this.$refs.form.resetFields()

            this.$message({message: '产品创建成功', type: 'success'})
            await this.getProduct()

          } else {
            this.$message.error('产品创建失败，错误信息: ' + result.message)
          }

        } else {
          await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      })
    },

    async getProduct() {
      this.loading = true
      const result = await reqProductInfo('/product/getProductList', this.currentPage, this.pageSize)
      if (result.code === 200) {
        this.tableData = result.data
        this.total  = result.data.total
        this.pageSize  = result.data.pageSize

        const result2 = await reqProductHasValidResource()
        this.productExpireDict = result2.data
        this.loading = false
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async deleteProduct (row) {
      this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const result = await reqDeleteProduct('/product/deleteProduct', row.productKey)
        if (result.code === 200) {
          this.$message({message: '删除成功', type: 'success'})
          await this.getProduct()
        } else {
          this.$message.error('删除失败，错误信息: ' + result.message)
        }
      }).catch(() => {
      });

    },

    purchase (row) {
      // this.$router.push({
      //   path: '/respkg',
      //   query: {productKey: row.productKey}
      // }).catch(err=>{})

      if (row.expireTime) {
        sessionStorage.setItem('expireTime', row.expireTime)
      } else {
        sessionStorage.setItem('expireTime', dateTimeFormatter(new Date()))
      }

      // 打开新的页面
      let {href} = this.$router.resolve(
        {
          path: '/vlrespkg',
          query: {
            productKey: row.productKey
          }
        }
      )
      window.open(href, '_blank')
    },

    async handleCurrentChange(val) {
      this.currentPage = val
      await this.getProduct()
    },

    isExpire(expireTime) {
      if (expireTime) {
        const date1 = new Date(expireTime)
        const now = new Date()
        return date1 < now
      } else {
        return true
      }
    },
  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

main {
  /*width: 100%;*/
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 82vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

.tip-ol-box {
  background-color: rgba(96, 149, 242, 0.3);
  padding: 10px 0px;
}

.tip-ol {
  color: #0C129A;
  font-size: 12px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/Product/Product.vue